import React from 'react';
import { Link } from 'react-router-dom';

interface LegalPageLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, lastUpdated, children }) => {
  return (
    <div className="legal-page">
      <header className="legal-page__top">
        <Link to="/login" className="legal-page__brand">
          <span className="legal-page__logo">wti</span>
          <span className="legal-page__brand-name">Where To Invest</span>
        </Link>
        <nav className="legal-page__nav" aria-label="Legal documents">
          <Link to="/user-agreement">User Agreement</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/login">Sign in</Link>
        </nav>
      </header>

      <main className="legal-page__main">
        <article className="legal-page__article card">
          <header className="legal-page__header">
            <h1>{title}</h1>
            <p className="legal-page__updated">Last updated: {lastUpdated}</p>
          </header>
          <div className="legal-page__body">{children}</div>
        </article>
      </main>

      <footer className="legal-page__footer">
        <p>
          © {new Date().getFullYear()} Where To Invest. All rights reserved.
        </p>
        <div className="legal-page__footer-links">
          <Link to="/user-agreement">User Agreement</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </footer>
    </div>
  );
};

export default LegalPageLayout;
